export default "__VITE_ASSET__rbWY8S2n__"